import React, {useContext} from "react";
import "./Skills.scss";
import {skillsSection} from "../../portfolio";
import {Fade} from "react-reveal";
import StyleContext from "../../contexts/StyleContext";

export default function Skills() {
  const {isDark} = useContext(StyleContext);
  if (!skillsSection.display) {
    return null;
  }
  return (
      <div className={isDark ? "dark-mode main skills-shell" : "main skills-shell"} id="skills">
        <Fade bottom duration={900} distance="24px">
          <div className="skills-header">
        <h1 className={isDark ? "dark-mode skills-heading" : "skills-heading"}>
          {skillsSection.title}
        </h1>
          </div>
        </Fade>
        <div className="skill-groups">
          {skillsSection.skillGroups.map((group, i) => (
            <Fade bottom duration={900} distance="24px" delay={i * 100} key={group.label}>
              <div className="skill-group">
                <span
                  className={
                    isDark
                      ? "dark-mode skill-group-label"
                      : "skill-group-label"
                  }
                >
                  {group.label}
                </span>
                <div className="skill-pills">
                  {group.skills.map((skill, j) => (
                    <span
                      key={j}
                      className={isDark ? "dark-mode skill-pill" : "skill-pill"}
                    >
                      {skill}
                    </span>
                  ))}
                </div>
              </div>
            </Fade>
          ))}
        </div>
      </div>
  );
}
